export const DMN_IND_OPERACAO_BEN_RECAD = {
  INCLUIR: "INC",
  EXCLUIR: "EXC",
  ALTERAR: "ALT"
};
